module.exports = __webpack_public_path__ + "assets/b4d27f4aa53b390f9343537e04e8e75c.mp3";